/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApplicationRejectionStep {
  REVIEW_SAFER = 'review_safer',
  BUSINESS_INFORMATION = 'business_information',
  TEXAS_AGENT = 'texas_agent',
  INTERSTATE_UCR = 'interstate_ucr',
  REGISTRATION_PERIOD = 'registration_period',
  CARGO_TYPES = 'cargo_types',
  VEHICLES = 'vehicles',
  DRUG_TEST_CERTIFICATION = 'drug_test_certification',
  QUESTIONNAIRE = 'questionnaire',
  BROKER_DOCUMENTS = 'broker_documents',
}
